export default __webpack_public_path__ + "static/media/filter_icon_auditorium_blue.a34ec687.svg";